/**
 * String utility functions for consistent text formatting
 */

/**
 * Normalize a name to Title Case (capitalize first letter of each word)
 * Used for plant names, variety names, etc.
 * Handles multiple spaces/tabs by splitting on any whitespace.
 * @param {string} name - The name to normalize
 * @param {string} fallback - Optional fallback value if name is empty/null
 * @returns {string|null} The normalized name, fallback, or null
 */
export const normalizeName = (name, fallback = null) => {
  if (!name) return fallback;
  const trimmed = name.trim();
  if (!trimmed) return fallback; // Whitespace-only input returns fallback
  return trimmed.split(/\s+/)
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

/**
 * Normalize a name for comparison/grouping purposes (lowercase, trimmed)
 * Useful for deduplicating or comparing plant names with different casing
 * @param {string} name - The name to normalize
 * @param {string} fallback - Optional fallback value if name is empty/null (defaults to '')
 * @returns {string} The normalized lowercase name, or fallback if name is empty
 */
export const normalizeForComparison = (name, fallback = '') => {
  if (!name) return fallback;
  return name.toLowerCase().trim();
};
